import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal } from "../../Modal";
import icons from "../../../constants/icons";
import ViewBalance from "./ViewBalance";
import { fetchWalletBalance } from "../../../queries/wallet/walletQuery";
import { getStorage } from "../../../utils/storage";

class Balances extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
    page: 0,
    limit: 10,
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const { merchantID } = await getStorage("merchantID");

      const { content, totalPages } = await fetchWalletBalance(
        defaultLanguage,
        {
          merchantId: merchantID,
        }
      );

      this.setState({
        isLoading: false,
        data: content,
        totalPageCount: totalPages,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].balance_id,
        key: "balanceId",
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "balanceType",
      },
      {
        title: language[this.props.defaultLanguage].balance,
        key: "balance",
      },
      {
        title: language[this.props.defaultLanguage].available_balance,
        key: "availableBalance",
      },
      {
        title: language[this.props.defaultLanguage].date,
        isMoment: true,
        formatTime: "lll",
        key: "dateCreated",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: language[this.props.defaultLanguage].view,
            onPress: (item) =>
              this.handleShowModal("showModal", item.walletType, item),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <ViewBalance
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Balances);
